import { EmptyObject } from 'libs/end-to-end/src/generic';
import { createCustomVizRequestSchema } from 'libs/end-to-end/src/custom-viz/createCustomVizRequestSchema';
import { z } from 'zod';

export const RichTextInputs = z.object({
  dropdowns: EmptyObject,
  extras: z.object({
    richText: z.object({
      serializedContent: z.string(),
      plainText: z.string(),
    }),
  }),
});

export const RichTextRequest = createCustomVizRequestSchema(
  'richText',
  RichTextInputs,
);

export type RichTextRequest = z.infer<typeof RichTextRequest>;

export const RichTextOutput = z
  .object({
    serializedContent: z.string(),
    plainText: z.string(),
  })
  .describe('RichTextOutput');

export type RichTextOutput = z.infer<typeof RichTextOutput>;

export const RichTextComponentSerializableProps = z.object({
  content: z.string(),
  isLoading: z.boolean(),
  isEditable: z.boolean(),
});

export type RichTextComponentSerializableProps = z.infer<
  typeof RichTextComponentSerializableProps
>;
